/**
 * Текст подробности состояния пожарной сигнализации.
 * Для fault — точные причины из API (как на вкладке «Оборудование»).
 */
export function firePanelDetailText(status, t, { hasNvr = true } = {}) {
  if (!hasNvr) return t('fire.panel.detail.not_connected');
  if (!status?.state) return t('fire.panel.detail.not_connected');

  if (status.state === 'ok') return t('fire.panel.detail.ok');
  if (status.state === 'not_connected') return t('fire.panel.detail.not_connected');
  if (status.state === 'unavailable') return t('fire.panel.detail.unavailable');
  if (status.state === 'on_fire') return t('fire.panel.detail.on_fire');

  const reasons = Array.isArray(status.reasons) && status.reasons.length > 0
    ? status.reasons
    : [
        ...(status.notReady ? [{ reason: 'fire_fault' }] : []),
        ...(status.misconfigured ? [{ reason: 'fire_contract' }] : []),
      ];

  if (reasons.length === 0) return t('fire.panel.detail.fault');

  return reasons
    .map(({ reason }) => t(`equipment.reasons.${reason}`, { count: 1 }))
    .filter(Boolean)
    .join('. ');
}
